import _ from 'lodash';
import * as types from '../../constant/actionTypes';

const intialState = {};

export default function (state = intialState, action) {
  switch (action.type) {
  case types.SYMBOL_SUMMARY_PAGE_API_SUCCESS: {
    const {
      year,
      month,
      data,
    } = action.payload;
    const newState = {
      ...state,
      [year]: {
        [month]: data,
      },
    };
    return newState;
  }
  case types.SYMBOL_SUMMARY_SYMBOL_DETAIL_SUCCESS: {
    const {
      year,
      month,
      data,
    } = action.payload;
    const idMap = data.reduce((pre, cur) => {
      pre[cur.id] = cur;
      return pre;
    }, {});
    const newState = {
      ...state,
      [year]: {
        [month]: {
          ...state[year][month],
          symbolDetail: state[year][month].symbolDetail
            ? _.assign({}, state[year][month].symbolDetail, idMap)
            : idMap,
        },
      },
    };
    return newState;
  }
  default:
    return state;
  }
}




// WEBPACK FOOTER //
// ./src/scenes/SymbolSummary/reducer.js